import styled from "styled-components";

const DashboardContainer = styled.div`
  margin-right: 40px;
  overflow: "auto";
`;

const HeaderContainer = styled.div`
  margin: 20px;
  display: flex;
  align-items: center;
`;

export { DashboardContainer, HeaderContainer };
